// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__VRi0m","dark":"Button_dark__Nrzfb","light":"Button_light__XjbgJ"};